/**
 * External Links Constants
 * Centralized external URLs used across the application
 */

// Booking/Demo scheduling link
export const BOOKING_LINK = 'https://cal.com/benjamin-pucci/30min';

// Auth routes for candidate
export const CANDIDATE_APPLY_ROUTE = '/auth/apply';
